import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
    return restApi.post("/api/purchase-order", params);
};

const getAllForCSV = params => {
    return restApi.post("/api/purchase-order/csv", params);
};

const get = id => {
    return restApi.get(`/api/purchase-order/${id}`);
};

const upsert = data => {
    return restApi.post("/api/purchase-order/save", data);
};

const remove = ids => {
    return restApi.delete(`/api/purchase-order/${ids}`);
};

const purchaseOrderService = {
    getAll,
    getAllForCSV,
    get,
    upsert,
    remove
};

export default purchaseOrderService;